// extracted by mini-css-extract-plugin
module.exports = {"emptyQuestion":"empty-question_emptyQuestion__16-QY","image":"empty-question_image__1TtBi","text":"empty-question_text__1oUwl"};